<template>
  <div class="h-full flex">
    <div class="m-auto">
      <div class="grid grid-cols-1 justify-items-center h-full w-full px-4 py-10">
        <div class="flex justify-center items-center">
          <svg-vue class="h-36 w-36 mb-12" icon="undraw.browsing"></svg-vue>
        </div>
        <div class="flex justify-center items-center">
          <div class="w-full font-semibold text-2xl">
            {{ $t('No records found') }}
          </div>
        </div>
        <template v-if="search">
          <div class="flex justify-center items-center">
            <div>
              {{ $t('Try changing the filters, or rephrasing your search') }}
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    search:{type:String|Object,default:null}
  }
};
</script>
